import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
import Box from '../Box';
import Typography from '../Typography';
import LoadingSpinner from '../LoadingSpinner';
function capitalize(string) {
    if (typeof string !== 'string') {
        throw new Error('StyleUtililityError: capitalize(string) expects a string argument.');
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const useStyles = makeStyles(({ palette, spacing }) => ({
    iconButtonRoot: {
        background: 'none',
        border: 'none',
        margin: 0,
        padding: 0,
        cursor: 'pointer',
        outline: 'none',
    },
    primary: {
        color: palette.secondary.main,
        '&:hover': {
            color: palette.secondary.dark,
        },
    },
    contained: {
        color: palette.secondary.contrastText,
        backgroundColor: palette.secondary.main,
        padding: spacing(0.5, 2),
        width: 'auto',
        border: 0,
        outline: 'none',
        borderRadius: 3,
        '&:hover': {
            backgroundColor: palette.secondary.dark,
        },
    },
    selected: {
        cursor: 'default',
        pointerEvents: 'none',
        fontWeight: 500,
    },
    disabled: {
        cursor: 'default',
        pointerEvents: 'none',
    },
    disabledPrimary: {
        color: palette.secondary.light,
        '&:hover': {
            color: palette.secondary.light,
        },
    },
    disabledContained: {
        color: palette.secondary.contrastText,
        backgroundColor: palette.secondary.light,
        '&:hover': {
            color: palette.secondary.contrastText,
            backgroundColor: palette.secondary.light,
        },
    },
    icon: {
        height: 24,
        width: 24,
    },
    label: {
        paddingLeft: spacing(0.5),
    },
}));
function IconButton({ onClick, icon, className, loading, disabled, label, variant = 'primary', alignItems = 'center', selected, }) {
    const classes = useStyles();
    const Icon = cloneElement(icon, {
        size: icon.props.size ? icon.props.size : 'mediumLarge',
    });
    return (React.createElement("button", { type: "button", disabled: disabled, className: classNames(className, classes.iconButtonRoot, {
            [classes[`disabled${capitalize(variant)}`]]: disabled || loading,
        }, { [classes.disabled]: disabled || loading }, [classes[variant]], { [classes.selected]: selected }), onClick: onClick },
        React.createElement(Box, { alignItems: alignItems },
            loading ? (React.createElement(LoadingSpinner, { color: variant === 'contained' ? '#FFFFFF' : undefined, size: "small" })) : (Icon),
            label && (React.createElement(Typography, { className: classes.label, variant: "body2" }, label)))));
}
export default IconButton;
//# sourceMappingURL=IconButton.js.map